/**
 * sun-cart-drawer-ajax.js — Patch du rendu AJAX du cart drawer
 *
 * Le thème Broadcast appelle `api-cart-items` pour re-rendre les items
 * du panier après une action AJAX (ajout, suppression, changement de quantité).
 * On le redirige vers `sun-api-cart-items` uniquement dans le contexte
 * du drawer, pour qu'il utilise notre snippet `sun-cart-line-item` redesigné.
 *
 * La page panier (template cart) continue d'utiliser `api-cart-items` original.
 *
 * Override JS transverse : ne modifie jamais le fichier original cart-items.js
 * du bundle Broadcast. Patch idempotent (drapeau `sunDrawerAjaxPatched`).
 *
 * Scope : chargé depuis sections/cart-drawer.liquid.
 */
(function () {
  const patchCartDrawerAjaxRendering = () => {
    const CartItemsElement = window.customElements.get('cart-items');
    if (!CartItemsElement || CartItemsElement.prototype.sunDrawerAjaxPatched) return;

    CartItemsElement.prototype.sunDrawerAjaxPatched = true;
    CartItemsElement.prototype.getCart = function () {
      const sectionId = this.closest('cart-drawer') ? 'sun-api-cart-items' : 'api-cart-items';

      fetch(window.theme.routes.cart_url + `?section_id=${sectionId}`)
        .then(this.cartErrorsHandler)
        .then((response) => response.text())
        .then((response) => {
          const element = document.createElement('div');
          element.innerHTML = response;

          const cleanResponse = element.querySelector('[data-api-content]');
          this.build(cleanResponse);
        })
        .catch((error) => console.log(error));
    };
  };

  if (window.customElements.get('cart-items')) {
    patchCartDrawerAjaxRendering();
  } else {
    window.customElements.whenDefined('cart-items').then(patchCartDrawerAjaxRendering);
  }
})();
